import script from "./FiltrosComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosComponent.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosComponent.vue?vue&type=style&index=0&id=c794d48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c794d48c"]])

export default __exports__